import * as React from 'react'
//
import '../../utils/fonts'

import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'

import { TDocument } from '../../types'
import utils from '../../utils'
import { styleConfig } from '../config'

interface HeaderProps {
	doc?: TDocument
}

export const Footer: React.FC<HeaderProps> = ({ doc }) => {
	const signature = utils?.getSignature(doc?.document)

	return (
		<View style={styles.footer}>
			<View style={styles.rowRemarks}>
				<View style={styles.remark}>
					<Text style={styles.text}>{doc?.document?.account?.remark}</Text>
				</View>
				<View style={styles.signature}>
					{signature ? (
						<Image src={signature} style={styles.image} />
					) : (
						<View style={{ height: `30mm` }} />
					)}
					<View style={styles.signatureLine} />
					<Text style={styles.practitioner}>
						{doc?.document?.bearer?.title ? `${doc?.document?.bearer?.title}, ` : ''}
						{doc?.document?.bearer?.firstName || ''}
						{doc?.document?.bearer?.firstName && doc?.document?.bearer?.lastName
							? ' '
							: ''}
						{doc?.document?.bearer?.lastName || ''}
					</Text>
				</View>
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	footer: {
		width: '100%',
	},
	rowRemarks: {
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		flexDirection: 'row',
		marginBottom: '1mm',
	},
	remark: {
		width: `${styleConfig?.fullWidth * 0.6}mm`,
		paddingRight: '20mm',
	},
	signature: {
		width: `${styleConfig?.fullWidth / 3}mm`,
		flexDirection: 'column',
	},
	signatureLine: {
		borderTop: '0.5px dashed #cccccc',
		height: '2mm',
	},
	image: {
		maxWidth: `50mm`,
		objectFit: 'contain',
		maxHeight: `30mm`,
	},
	text: {
		fontSize: styleConfig?.fontSize,
	},
	practitioner: {
		fontSize: 9,
		textAlign: 'center',
	},
})
